import { render, staticRenderFns } from "./AccountType.vue?vue&type=template&id=0cc4bf74&scoped=true"
import script from "./AccountType.vue?vue&type=script&lang=js"
export * from "./AccountType.vue?vue&type=script&lang=js"
import style0 from "./AccountType.vue?vue&type=style&index=0&id=0cc4bf74&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc4bf74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cc4bf74')) {
      api.createRecord('0cc4bf74', component.options)
    } else {
      api.reload('0cc4bf74', component.options)
    }
    module.hot.accept("./AccountType.vue?vue&type=template&id=0cc4bf74&scoped=true", function () {
      api.rerender('0cc4bf74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/account/AccountType.vue"
export default component.exports